import React from "react"

/* Import Local Styles */
import "../icon.css"

const HeartFilledSvg = () => (
  <svg
    className="icon no-fill"
    viewBox="0 0 61 50"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M50.7 1.29983C35.6 -4.80017 30.8 13.1998 30.8 13.1998C30.8 13.1998 28.8 6.49983 22.5 3.09983C19.5 1.49983 15.6 0.699826 10.5 1.69983C-5.50001 4.79983 1.59999 19.1998 1.59999 19.1998C1.59999 19.1998 3.69999 20.6998 4.79999 21.5998C5.89999 22.4998 6.99999 23.2998 7.99999 24.0998C12.4 27.7998 16.7 31.9998 20.7 36.4998C24.7 41.0998 28.1 45.4998 30.8 49.9998C33.4 45.5998 36.7 41.0998 40.8 36.4998C44.9 31.8998 49.1 27.7998 53.5 24.0998C54.6 23.2998 55.7 22.4998 56.8 21.5998C57.8 20.6998 58.9 19.8998 60 19.1998C59.9 19.1998 65.8 7.39983 50.7 1.29983Z"
      className="fill-with-text-color"
    />
  </svg>
)

export default HeartFilledSvg
